import { LabelGrouping } from '@aibees/elephant/types/label';
import { DropDownOption } from '@aibees/shared/components';
import { IconName } from '@aibees/shared/components/icon';
import { useState } from 'react';
import { CONFIG } from './config';

export const useSelectLabelGroupingStatus = () => {
  const [value, setValue] = useState(CONFIG[0].value);

  const handleChange = (newValue: string) => {
    setValue(newValue);
    return newValue as LabelGrouping;
  };

  const options: DropDownOption[] = CONFIG.map((item) => ({
    key: item.key || item.value,
    value: item.value,
    label: item.value === LabelGrouping.PEOPLE ? 'People' : 'Company',
    startIcon: item.icon as IconName,
    startIconSx: item.iconSx,
  }));

  return {
    value,
    options,
    handleChange,
  };
};
